module.exports = __webpack_public_path__ + "media/acmi.2f4b2127.mp4";